module.exports = __webpack_public_path__ + "static/media/zoleWon_100_250.876bbbee.png";